// Mock data for PBX Solutions website

export const mockCompanyInfo = {
  name: "PBX Solutions",
  tagline: "Streamline Your Back-Office Operations",
  description: "Expert data management, invoice auditing, and payable services for importing, exporting, and manufacturing companies.",
  foundedYear: 2008,
  employeeCount: "150+",
  clientCount: "500+",
  accuracyRate: "Self-improving",
  supportAvailability: "24/7"
};

export const mockServices = [
  {
    id: 1,
    name: "Invoice Auditing",
    shortDescription: "Comprehensive auditing for freight, utilities, and supplier invoices",
    longDescription: "Our expert team provides thorough invoice auditing services across freight, utilities, and general supplier invoices. We identify discrepancies, prevent overpayments, and ensure complete accuracy in your accounts payable processes.",
    features: [
      "Freight invoice verification and audit",
      "Utility bill analysis and validation", 
      "Supplier invoice accuracy checks",
      "Automated discrepancy detection",
      "Detailed audit reports and recommendations"
    ],
    benefits: [
      "Reduce invoice processing errors by 95%",
      "Save 20-30% on operational costs",
      "Improve vendor relationship management",
      "Ensure regulatory compliance"
    ]
  },
  {
    id: 2,
    name: "Data Intelligence",
    shortDescription: "Advanced analytics and business intelligence solutions",
    longDescription: "Transform your raw data into actionable insights with our comprehensive data intelligence platform. We provide real-time analytics, predictive modeling, and custom reporting to drive informed business decisions.",
    features: [
      "Real-time dashboard and reporting",
      "Predictive analytics and forecasting",
      "Custom KPI tracking and monitoring", 
      "Data visualization and presentation",
      "Automated report generation"
    ],
    benefits: [
      "Make data-driven decisions faster",
      "Identify cost-saving opportunities", 
      "Improve operational efficiency",
      "Gain competitive market insights"
    ]
  },
  {
    id: 3,
    name: "Escalation Handling",
    shortDescription: "Professional dispute and escalation management",
    longDescription: "Our experienced team manages all vendor disputes and escalations on your behalf. We handle negotiations, maintain professional relationships, and ensure swift resolution of any issues that arise.",
    features: [
      "Professional dispute resolution",
      "Vendor negotiation and communication",
      "Issue tracking and status updates",
      "Documentation and record keeping", 
      "Escalation prevention strategies"
    ],
    benefits: [
      "Maintain positive vendor relationships",
      "Reduce resolution time by 60%",
      "Professional representation",
      "Focus on core business activities"
    ]
  },
  {
    id: 4,
    name: "Payable Services", 
    shortDescription: "Secure payment processing on behalf of clients",
    longDescription: "We handle all aspects of your accounts payable process, from invoice processing to payment execution. Our secure platform ensures timely payments while maintaining complete transparency and control.",
    features: [
      "Automated payment processing",
      "Multi-currency payment support",
      "Secure payment gateway integration",
      "Payment scheduling and approval workflows",
      "Detailed payment tracking and reporting"
    ],
    benefits: [
      "Ensure timely vendor payments",
      "Reduce payment processing costs", 
      "Maintain cash flow control",
      "Enhanced security and compliance"
    ]
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    position: "CFO",
    company: "Global Manufacturing Inc.",
    text: "PBX Solutions transformed our invoice processing. We've saved countless hours and significantly reduced errors. Their team is professional, responsive, and truly understands our business needs.",
    rating: 5,
    industry: "Manufacturing"
  },
  {
    id: 2,
    name: "Michael Chen", 
    position: "Operations Director",
    company: "Pacific Import Co.",
    text: "Their data intelligence capabilities have given us insights we never had before. The reporting dashboards are intuitive and the cost savings have been substantial. Highly recommended.",
    rating: 5,
    industry: "Import/Export"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    position: "Finance Manager", 
    company: "Atlantic Logistics",
    text: "The escalation handling service has been a game-changer for our vendor relationships. Issues that used to take weeks to resolve are now handled in days, professionally and efficiently.",
    rating: 5,
    industry: "Logistics"
  }
];

export const mockTeamMembers = [
  {
    id: 1,
    name: "David Thompson",
    position: "CEO & Founder",
    bio: "With over 20 years in financial services and data management, David founded PBX Solutions to help businesses optimize their back-office operations.",
    expertise: ["Financial Operations", "Business Strategy", "Client Relations"]
  },
  {
    id: 2,
    name: "Jennifer Walsh",
    position: "VP of Operations", 
    bio: "Jennifer leads our operations team with 15 years of experience in invoice auditing and process optimization for import/export companies.",
    expertise: ["Invoice Auditing", "Process Optimization", "Team Leadership"]
  },
  {
    id: 3,
    name: "Robert Kim",
    position: "Head of Data Intelligence",
    bio: "Robert specializes in transforming complex business data into actionable insights, with expertise in analytics and reporting systems.",
    expertise: ["Data Analytics", "Business Intelligence", "Reporting Systems"]
  }
];

export const mockStats = {
  invoicesProcessed: "2.5M+",
  costSavingsGenerated: "Real Time",
  averageProcessingTime: "24 hours",
  clientRetentionRate: "Top Quartile",
  yearsInBusiness: "15+",
  countriesServed: "25+"
};

export const mockContactInfo = {
  phone: "+1 (713) 364-3437",
  email: "fpigatto@pbxsolutions.ai",
  address: {
    street: "1942 W Gray St",
    suite: "Ste 1137", 
    city: "Houston",
    state: "TX",
    zipCode: "77019"
  },
  businessHours: {
    weekdays: "8:00 AM - 6:00 PM CST",
    weekends: "Emergency support available"
  }
};

export const mockIndustries = [
  {
    name: "Import/Export Companies",
    description: "Specialized services for international trade businesses dealing with complex freight and customs documentation.",
    challenges: ["Complex freight invoices", "Multi-currency transactions", "Customs compliance"],
    solutions: ["Automated freight auditing", "Currency conversion tracking", "Compliance reporting"]
  },
  {
    name: "Manufacturing Companies", 
    description: "Comprehensive back-office support for manufacturers managing supplier networks and utility costs.",
    challenges: ["Multiple supplier invoices", "Utility cost management", "Vendor relationship complexity"],
    solutions: ["Supplier invoice automation", "Utility bill optimization", "Vendor performance tracking"]
  }
];

// Mock form submission handler
export const mockFormSubmission = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Mock form submission:", formData);
      resolve({
        success: true,
        message: "Thank you for your inquiry! We'll contact you within 24 hours.",
        submissionId: Math.random().toString(36).substr(2, 9)
      });
    }, 1500);
  });
};